import { render, staticRenderFns } from "./Hongbao.vue?vue&type=template&id=c278da8a&scoped=true&"
import script from "./Hongbao.vue?vue&type=script&lang=js&"
export * from "./Hongbao.vue?vue&type=script&lang=js&"
import style0 from "./Hongbao.vue?vue&type=style&index=0&id=c278da8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c278da8a",
  null
  
)

export default component.exports